// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3y7ET","modalForm":"UpgradeEpcsModal_modalForm__2GytS","modalFooter":"UpgradeEpcsModal_modalFooter__aenIL"};